import { DataField } from "../dataFields";
import { IRequireable, MultipleItemRequirement, SingleItemRequirement } from "../requirements";


export class DataFieldTemplate implements IRequireable {
	public static readonly $type: string = "DataFieldTemplate";
	public readonly $type: string = DataFieldTemplate.$type;

	public id?: number;
	public name!: string;
	public field!: DataField;
	public stringPrefix!: string;
	public stringAppendage!: string;
	public getParent?(): SingleItemRequirement<DataFieldTemplate> | MultipleItemRequirement<DataFieldTemplate>;
}
